import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";
import { useContent } from "../context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const c = content?.contact || {};
  const l = content?.external_links || {};
  return (
    <footer className="bg-forest text-cream/80" data-testid="footer">
      <div className="container-lux py-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div className="min-w-0 sm:col-span-2">
          {content?.logo_url ? <img src={content.logo_url} alt="The Rose Air BnB" className="h-56 w-auto object-contain mb-3 mx-auto" /> : <div className="font-serif text-3xl text-cream mb-3 text-center">The Rose Air <span className="text-gold">BnB</span></div>}
          <p className="text-sm max-w-md leading-relaxed text-cream/70">
            An exclusive luxury mountain retreat in the misty highlands of Mutare, Zimbabwe. Boutique comfort, wild beauty, unforgettable experiences.
          </p>
          <div className="flex gap-4 mt-6">
            {l.instagram && <a href={l.instagram} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/5 hover:bg-white/10 transition-colors" aria-label="Instagram"><Instagram size={18} /></a>}
            {l.facebook && <a href={l.facebook} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/5 hover:bg-white/10 transition-colors" aria-label="Facebook"><Facebook size={18} /></a>}
          </div>
        </div>
        <div className="min-w-0">
          <h4 className="eyebrow mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/accommodation" className="hover:text-gold transition-colors">Accommodation</Link></li>
            <li><Link to="/gallery" className="hover:text-gold transition-colors">Gallery</Link></li>
            <li><Link to="/experiences" className="hover:text-gold transition-colors">Experiences</Link></li>
            <li><Link to="/booking" className="hover:text-gold transition-colors">Book a Stay</Link></li>
            <li><Link to="/admin" className="hover:text-gold transition-colors">Admin Portal</Link></li>
          </ul>
        </div>
        <div className="min-w-0">
          <h4 className="eyebrow mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2 min-w-0"><MapPin size={16} className="text-gold mt-0.5 shrink-0" /> <span className="break-words min-w-0">{c.address || "Vumba, Mutare, Zimbabwe"}</span></li>
            <li className="flex items-center gap-2 min-w-0"><Phone size={16} className="text-gold shrink-0" /> <span className="break-words min-w-0">{c.phone || "+263 77 000 0000"}</span></li>
            <li className="flex items-center gap-2 min-w-0"><Mail size={16} className="text-gold shrink-0" /> <span className="break-words min-w-0">{c.email || "stay@theroseairbnb.com"}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-cream/50">
        <p className="font-bold text-cream/80 mb-1" data-testid="footer-owner">{content?.footer_text || "The Mapunde Family Trust"}</p>
        © {new Date().getFullYear()} The Rose Air BnB · www.theroseairbnb.com · Mutare, Zimbabwe
      </div>
    </footer>
  );
}
